const actions = {
  CLEAR_STATE: 'root/CLEAR_STATE',
}

export default actions
